
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cnc-rfq",
      function () {
        return require("private-next-pages/cnc-rfq/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cnc-rfq"])
      });
    }
  